import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import FindResourcesPage from "./pages/FindResourcesPage";
import AddResourcePage from "./pages/AddResourcePage";
import EditResourcePage from "./pages/EditResourcePage";
import ResourceDetailPage from "./pages/ResourceDetailPage";
import ImportResourcesPage from "./pages/ImportResourcesPage";
import PrintableHandout from "./pages/PrintableHandout";
import PublicSharePage from "./pages/PublicSharePage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import NotFoundPage from "./pages/NotFoundPage";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ReachLoader } from "./components/ReachLoader";

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <ReachLoader fullScreen label="Loading 617Reach…" />;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Public Route component (redirect to home if logged in)
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <ReachLoader fullScreen label="Loading 617Reach…" />;
  }
  
  if (user) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route 
        path="/login" 
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        } 
      />
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <FindResourcesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/add" 
        element={
          <ProtectedRoute>
            <AddResourcePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/edit/:id" 
        element={
          <ProtectedRoute>
            <EditResourcePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/import" 
        element={
          <ProtectedRoute>
            <ImportResourcesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/resource/:id" 
        element={
          <ProtectedRoute>
            <ResourceDetailPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/print" 
        element={
          <ProtectedRoute>
            <PrintableHandout />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminSettingsPage />
          </ProtectedRoute>
        } 
      />
      {/* Public route for clients (no auth needed) */}
      <Route path="/share" element={<PublicSharePage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
          <Toaster 
            position="top-center" 
            toastOptions={{
              className: 'dark:!bg-[#271D15] dark:!text-[#E8DFD3] dark:!border-[#3B2D21]',
              style: {
                borderRadius: '16px',
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
